import ReactMarkdown from 'react-markdown';
import mountain from '../../assets/mountain.png';
import './About.scss';

const About = ({ metadata, translation }: any) => {
    return (
        <div className='about-container'>
            <div className='info'>
                <div>
                    <h1 className='title green-text'>
                        <ReactMarkdown>
                            {translation('landing.whatIsCo2Title')}
                        </ReactMarkdown>
                    </h1>
                </div>
                <div className='grey-text'>
                    <ReactMarkdown>
                        {translation('landing.whatIsCo2Description').replace(
                            '{companyPlaceholder}',
                            metadata?.CompanyName || 'company'
                        ).replace(
                            '{levelPlaceholder}',
                            metadata?.level?.toLowerCase() || ''
                        )}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
};

export default About;
